import React, { createContext, useState, useContext } from "react";

const ModalBalanceContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalBalanceVisible, setIsModalBalanceVisible] = useState(false);

  return (
    <ModalBalanceContext.Provider
      value={{ isModalBalanceVisible, setIsModalBalanceVisible }}
    >
      {children}
    </ModalBalanceContext.Provider>
  );
};

export const useModal = () => useContext(ModalBalanceContext);
